export class TenantSettingsReportsDto {
  rentalAgreements?: {
    email?: {
      customer?: {
        confirmation?: {
          reportId?: number | null;
        };
      };
    };
    print?: {
      agreement?: {
        reportId?: number | null;
      };
    };
  } | null;
  rentalReservations!: {
    email: {
      customer: {
        requestConfirmation: {
          reportId: number;
        };
        acceptedRequestConfirmation: {
          reportId: number;
        };
        rejectedRequestConfirmation: {
          reportId: number;
        };
      };
    };
  };
  payments?: {
    email?: {
      paymentRequest?: {
        reportId?: number | null;
      };
    };
  } | null;
}
